import React from 'react';
import { observer } from 'mobx-react';
import { RouterState, routerStateToUrl } from 'mobx-state-router';

const ORDER_DETAIL_ROUTE = 'master.app.main.order.list.detail';

function getOrderDetailUrl(routerStore, id) {
	const toState = new RouterState(ORDER_DETAIL_ROUTE, { id });
	return routerStateToUrl(routerStore, toState);
}

const STATUS_LABELS = { awaitingPickup: 'Awaiting Pickup', enRoute: 'En Route', exception: 'Exception' };
const STATUS_COLORS = { awaitingPickup: '#f5a623', enRoute: '#2ec4a5', exception: '#e85d75' };

function formatTime(val) {
	if (!val) return '—';
	const d = new Date(val);
	if (isNaN(d.getTime())) return '—';
	return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

const TrackingGridModal = observer(({ viewStore }) => {
	const { gridLoading, gridError, gridShipments, orgType } = viewStore;
	const showWarehouse = orgType !== 'Warehouse';
	const showSeller = orgType !== 'Seller';

	return (
		<div className="modal-overlay">
			<div className="modal modal--wide">
				<div className="modal__header">
					<span className="modal__title">Shipments</span>
					<div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
						{!gridLoading && !gridError && gridShipments.length > 0 && (
							<button
								className="modal__export-btn"
								onClick={() => viewStore.exportGridToCsv({ showSeller, showWarehouse })}
							>
								Export CSV
							</button>
						)}
						<button className="modal__close" onClick={() => viewStore.closeGridView()}>✕</button>
					</div>
				</div>

				{gridLoading && (
					<div className="chart-card__loading">Loading...</div>
				)}

				{gridError && (
					<p className="chart-card__error">{gridError}</p>
				)}

				{!gridLoading && !gridError && (
					<div className="grid-view-wrap">
						<table className="grid-view-table">
							<thead>
								<tr>
									<th>Tracking #</th>
									<th>FO #</th>
									<th>Carrier</th>
									<th>Status</th>
									{showWarehouse && <th>Warehouse</th>}
									{showSeller && <th>Client</th>}
									<th>Last Update</th>
									<th>Label Created</th>
								</tr>
							</thead>
							<tbody>
								{gridShipments.length === 0 && (
									<tr>
										<td colSpan={4 + (showWarehouse ? 1 : 0) + (showSeller ? 1 : 0) + 2} style={{ textAlign: 'center', color: '#7a8899' }}>
											No shipments found
										</td>
									</tr>
								)}
								{gridShipments.map((s, idx) => (
									<tr key={s.trackingNumber || idx}>
										<td className="grid-view-table__id">{s.trackingNumber}</td>
										<td>
											{s.id && s.fulfillmentOrderId ? (
												<a
													className="grid-view-table__link"
													href={getOrderDetailUrl(viewStore.rootStore.routerStore, s.id)}
													target="_blank"
													rel="noopener noreferrer"
												>
													{s.fulfillmentOrderId}
												</a>
											) : (
												s.fulfillmentOrderId || '—'
											)}
										</td>
										<td>{s.carrier}</td>
										<td>
											<span
												className="grid-view-badge"
												style={{
													background: `${STATUS_COLORS[s.trackingStatus]}22`,
													color: STATUS_COLORS[s.trackingStatus],
												}}
											>
												{STATUS_LABELS[s.trackingStatus] || s.trackingStatus}
											</span>
										</td>
										{showWarehouse && <td>{s.warehouseName}</td>}
										{showSeller && <td>{s.sellerName}</td>}
										<td>{s.lastUpdate ? String(s.lastUpdate).slice(0, 10) : '—'}</td>
										<td>{s.labelCreatedDate ? `${String(s.labelCreatedDate).slice(0, 10)} ${formatTime(s.labelCreatedDate)}` : '—'}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
});

export default TrackingGridModal;